import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-is-checked',
    templateUrl: './is-checked.component.html',
    standalone: false
})
export class IsCheckedComponent {
  @Input() show: boolean = true
  @Input() isChecked: boolean = false
  @Input() isClickable: boolean = false
  @Input() style: 'dark' | 'gray' = 'dark'
}
